import { graphql } from 'react-relay';

export const linkSectionFragment = graphql`
    fragment LinkSection_pageSection on LinkSection {
        title
        titleImageUrl
        titleImageBackgroundUrl
        anchorName
        linkSectionText: text
        links {
            ...ComplexLink_complexLink
        }
    }
`;
